import type { MapEventType } from 'maplibre-gl';
import { useEffect, useEffectEvent } from 'react';
import { useMap } from './mapContext';

/** Subscribes to a map event for the component's lifetime; the handler always sees fresh props/state. */
export function useMapEvent<T extends keyof MapEventType>(type: T, handler: (e: MapEventType[T]) => void) {
  const map = useMap();
  const onEvent = useEffectEvent(handler);

  useEffect(() => {
    if (!map) return;
    const listener = (e: MapEventType[T]) => onEvent(e);
    map.on(type, listener);
    return () => void map.off(type, listener);
  }, [map, type]);
}
